import React from "react";

const staticHomeData = {
  homeValue: {
    title: "Home Value",
    tableHeader: "Home Value Information",
    note: (
      <span>
        <span className={"red-text"}>{"* "}</span>Note that average home values
        are based on data compiled from various sources, and may or may not be
        indicative of your subject{"'"}s actual property value.
      </span>
    ),
  },
  homeIncome: {
    title: "Household Income",
    tableHeader: "Income Information",
    note: (
      <span>
        <span className={"red-text"}>{"* "}</span>Note that average income
        values are based on data compiled from various sources, and may or may
        not be indicative of your subject{"'"}s actual income.
      </span>
    ),
  },
};

export default staticHomeData;



// WEBPACK FOOTER //
// ./src/components/common/HomeValue.js